// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drcyj-product h6 {
    /* padding-top: 0!important; */
    color: #19254F !important;
    font-family: "ParagraphFonts", serif !important;
    font-weight: bold;
    margin-bottom: 8px;

}

@media(min-width: 992px) {
    .drcyj-product .container{
        padding-left: 176px !important;
        padding-right: 176px !important;
    }

    /* html[dir='rtl']  .drcyj-product{
   }  */
    .drcyj-product h6 {
        font-size: 14px !important;
    }

    .drcyj-product li {
        font-size: 13px !important;
    }


}

@media(min-width:768px) and (max-width:991px) {
    .drcyj-product {
        padding-left: 64px !important;
        padding-right: 64px !important;
    }

    .drcyj-product h5,
    .drcyj-product h6 {
        font-size: 11px !important;
        font-weight: 600 !important;

    }

    .drcyj-product p,
    .drcyj-product li {
        font-size: 9px !important;
    }

}`, "",{"version":3,"sources":["webpack://./src/pages/brands/components/DrcyjProductComponent.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,+CAA+C;IAC/C,iBAAiB;IACjB,kBAAkB;;AAEtB;;AAEA;IACI;QACI,8BAA8B;QAC9B,+BAA+B;IACnC;;IAEA;OACG;IACH;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;;AAGJ;;AAEA;IACI;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;;QAEI,0BAA0B;QAC1B,2BAA2B;;IAE/B;;IAEA;;QAEI,yBAAyB;IAC7B;;AAEJ","sourcesContent":[".drcyj-product h6 {\n    /* padding-top: 0!important; */\n    color: #19254F !important;\n    font-family: \"ParagraphFonts\", serif !important;\n    font-weight: bold;\n    margin-bottom: 8px;\n\n}\n\n@media(min-width: 992px) {\n    .drcyj-product .container{\n        padding-left: 176px !important;\n        padding-right: 176px !important;\n    }\n\n    /* html[dir='rtl']  .drcyj-product{\n   }  */\n    .drcyj-product h6 {\n        font-size: 14px !important;\n    }\n\n    .drcyj-product li {\n        font-size: 13px !important;\n    }\n\n\n}\n\n@media(min-width:768px) and (max-width:991px) {\n    .drcyj-product {\n        padding-left: 64px !important;\n        padding-right: 64px !important;\n    }\n\n    .drcyj-product h5,\n    .drcyj-product h6 {\n        font-size: 11px !important;\n        font-weight: 600 !important;\n\n    }\n\n    .drcyj-product p,\n    .drcyj-product li {\n        font-size: 9px !important;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
